import { ComponentFixture } from '@angular/core/testing';
import { By } from '@angular/platform-browser';
import { Params, RequestFilters, RequestOrdering } from 'src/app/core/interfaces/shared.interface';

export const triggerEvent = (fixture: ComponentFixture<any>, selector: string, eventName: string, eventObject?: any) => {
  const element = fixture.debugElement.query(By.css(selector));
  element.triggerEventHandler(eventName, eventObject);
  fixture.detectChanges();
};

export function parsePaginationParams(filters: Partial<RequestFilters> = {}, order?: RequestOrdering): Params | Record<string, any> {
  let params: Record<string, any> | Params;

  const { page, limit, ...filterParams } = filters;

  if (page !== undefined) {
    const offset = page * (limit || 10);

    params = { limit: limit || 10, offset };
  }

  if (order?.active) {
    params = { ...params, order_by: `${order.direction === 'desc' ? '-' : ''}${order.active}` };
  }

  return { ...params, ...filterParams };
}

export function serverBaseUrl(baseUrl: string) {
  const url = new URL(baseUrl);
  url.pathname = '';
  return url.href;
}
